import { useEffect } from "react";
import { useParams } from "react-router-dom";

export default function ReferPage() {
  const { code } = useParams(); // will get XDPJ8PW6 from /refer/:code

  useEffect(() => {
    const ua = navigator.userAgent.toLowerCase();
    const isAppleDevice =
      /iphone|ipad|ipod|mac os/i.test(ua) || navigator.userAgentData?.platform === "iOS" || navigator.userAgentData?.platform === "macOS";

    if (isAppleDevice) {
      window.location.href = "https://apps.apple.com/us/app/goertrip/id6741723959";
    } else {
      window.location.href =
        "https://play.google.com/store/apps/details?id=com.catpl.goertrip";
    }
  }, []);

  return (
    <div className="flex items-center justify-center h-screen">
      <p className="text-lg font-semibold">Redirecting...</p>
    </div>
  );
}
